var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "middle error text-4xl"
  }, [_c('i', {
    staticClass: "text-red-600 fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.message) + " ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }